import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ISO1 from "../Images/fotter_logo.png"


const Footer = () => {
  const navigate = useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div className="contact-footer-wrapper">

      {/* ================= CTA SECTION ================= */}
      <section className="cta-section">
        <div className="cta-inner">
          <p className="cta-top">Contact Us</p>
          <div className="cta-line"/>

          <p className="cta-highlight">Interested in our Services ?</p>

          <h1 className="cta-title"  onClick={() => navigate("/contact")}>
            Talk to us now
            <span className="cta-arrow">→</span>
          </h1>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="footer-section">
      {/* Address Row with Vertical Divider */}
      <div className="footer-address">
        <div className="address-block">
          <h3>Corporate Headquarters</h3>
          <p>
            23A/15A Abayomi Shonuga Crescent, Lekki Phase 1,
            Lagos State., Nigeria.
          </p>
        </div>

        <div className="address-vertical-divider"></div>

        <div className="address-block">
          <h3>Operational Office</h3>
          <p>
            344 Akhigbe Road, Trans-Amadi Industrial Layout Rd,
            Trans Amadi, Port Harcourt 500101, Rivers
          </p>
        </div>
      </div>

      <div className="footer-divider"></div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="company">
          <h2>Jeyshawn Engineering Limited</h2>
          <p>
            We committed to delivering word-class solutions
            to the oil and gas, energy, marine and infrastructure sectors.
          </p>
        </div>

        <div className="footer-links">
          <div>
            <h4>PAGES</h4>
            <Link to="/">Home</Link>
            <Link to="/company">About Us</Link>
            <Link to="/engineering">Our Services</Link>
          </div>

          <div>
            <h4>CONTACT</h4>
            <a href="mailto:Info@jeyshawnng.com">Info@jeyshawnng.com</a>
            <a href="mailto:jeyshawn2012@gmail.com">jeyshawn2012@gmail.com</a>
            <a href="tel:+2348112790741">+234 8112 790 741</a>
          </div>
        </div>
      </div>

      <div className="footer-divider"></div>

      {/* Copyright with ISO Badges */}
      <div className="copyright">
        <div className="copyright-left">
          <div className="iso-badges">
            <img src={ISO1} alt="ISO Certification" />
          </div>
          <p>© 2026 Jeyshawn Engineering limited. All rights reserved.</p>
        </div>

        <div className="socials">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
    </footer>
    </div>
  );
};

export default Footer; 